export {mzData} from './mzData';



//////////////////
// WEBPACK FOOTER
// ./node_modules/mzmjs/src/index.js
// module id = 93
// module chunks = 0